/**
 * @file   连连看
 * @create macaiqi 2025/07/14
 * @update 
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './index.scss'

export default function LLK() {
    const navigate = useNavigate()
    return (
        <div className='llk-page'>
            <div className="logo  animate__animated   animate__zoomIn"></div>
            <div className="start  animate__animated animate__pulse animate__slow animate__infinite" onClick={() => {
                navigate('/LLK/Choose')
            }}>进入游戏</div>
            <div
                className="back"
                onClick={() => {
                    navigate('/')
                }}
            />
        </div>
    )
}
